
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/portfolio-grid",
      function () {
        return require("private-next-pages/portfolio-grid.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/portfolio-grid"])
      });
    }
  